


export class TokenAcesso {
  "codigo";
  "id";
  "ttl";
  "scopes";
  "created";
  "userId";
  "principalType";
  user;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TokenAcesso`.
   */
  static getModelName() {
    return "TokenAcesso";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TokenAcesso for dynamic purposes.
  **/
  static factory(data) {
    return new TokenAcesso(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'TokenAcesso',
      plural: 'TokenAcessos',
      path: 'TokenAcessos',
      properties: {
        "codigo": {
          name: 'codigo',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'string'
        },
        "ttl": {
          name: 'ttl',
          type: 'number',
          default: 1209600
        },
        "scopes": {
          name: 'scopes',
          type: 'Array&lt;any&gt;'
        },
        "created": {
          name: 'created',
          type: 'Date'
        },
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "principalType": {
          name: 'principalType',
          type: 'string'
        },
      },
      relations: {
        user: {
          name: 'user',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/TokenAcesso.js